<template src="./index.html"></template>
<script>
	import {
		getdata
	} from './data.js';
	import {
		findConpanyConfig
	} from '../../../../../../api/Draftgeneration.js';
	export default {
		name: '',
		components: {},
		data: function() {
			return {
				headDataI: getdata().headDataI,
				// tableDataI: getdata().tableDataI,
				headDataII: getdata().headDataII,
				// tableDataII: getdata().tableDataII,
				delCells: [],
				delCells_II: [],
			};
		},
		props: {
			params: {
				type: Object,
				default: {}
			},
			showpz: {
				type: Boolean,
				default: false
			},
			tableDataI: {
				type: Array,
				default: []
			},
			tableDataII: {
				type: Array,
				default: []
			},
			optionxfs: {
				type: Array,
				default: []
			},
			headobj: {
				type: Object,
				default: {}
			},
			choosecellCode: {
				type: String,
				default: ''
			},
			type: {
				type: String,
				default: ''
			},
			toseeUpdate: {
				type: Boolean,
				default: false
			}
		},
		created() {},
		methods: {
			headchange() {
				this.$emit('headchange', this.headobj);
			},
			inputblur(e) {
				this.$emit('inputblur', e);
			},
			selectchangetwo(e, ve, table, colum, index) {
				optionxdansha(this.optionxfs)

				function optionxdansha(data) {
					ve['xfs_4_x_1.1'].cellType = '1'
					ve['xfs_4_x_1.2'].cellType = '1'
					data.forEach(item => {
						if (item.value == e) {
							ve['xfs_4_x_1.2'].cellVal = item.label
							if (item.type == '1') {
								ve['xfs_4_x_6'].cellVal = (parseFloat(item.shuil) * 100).toFixed(2)
								ve['xfs_4_x_5'].cellVal = '0'
								ve['xfs_4_x_3'].cellVal = '0'
							} else if (item.type == '2') {
								ve['xfs_4_x_5'].cellVal = (item.shuil).toString()
								ve['xfs_4_x_6'].cellVal = '0.00'
								ve['xfs_4_x_4'].cellVal = '0'
							}
						} else {
							if (item.children) {
								optionxdansha(item.children)
							}
						}
					})
				}
				this.tableDataII[index]['xfs_4_x_1.1'].cellVal = ve['xfs_4_x_1.1'].cellVal
				this.$emit('forhover', table, colum, index);
				this.$emit('inputblur', ve[colum]);
				this.$emit('inputblur', ve['xfs_4_x_5']);
				this.$emit('inputblur', ve['xfs_4_x_6']);
			},
			forhover(table, colum, index) {
				this.$emit('forhover', table, colum, index);
			},
			zcsclick(e) {
				this.$emit('zcsclick', e);
			},
			fordelete(tableData, index) {
				if (this.tableDataI.length < 3) {
					return false;
				}
				if (this.$notemptyandnull(this.tableDataI[index]['xfs_4_x_2'].id)) {
					this.delCells.push(JSON.parse(JSON.stringify(this.tableDataI[index])));
					this.delCells_II.push(JSON.parse(JSON.stringify(this.tableDataII[index])));
				}
				this.tableDataI.splice(index, 1);
				this.tableDataII.splice(index, 1);
				this.$emit('delCellsCode', this.delCells, 'IIIIHead');
				this.$emit('delCellsCode', this.delCells_II, 'IIIIIHead');
			},
			foraddhang() {
				let hanh = this.tableDataI.length
				let table = {
					hanh: hanh,
					"xfs_4_x_1.1": {
						cellCode: "xfs_4_" + hanh + "_1.1",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_4_x_1.2": {
						cellCode: "xfs_4_" + hanh + "_1.2",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_4_x_2": {
						cellCode: "xfs_4_" + hanh + "_2",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_4_x_3": {
						cellCode: "xfs_4_" + hanh + "_3",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_4_x_4": {
						cellCode: "xfs_4_" + hanh + "_4",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_4_x_5": {
						cellCode: "xfs_4_" + hanh + "_5",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_4_x_6": {
						cellCode: "xfs_4_" + hanh + "_6",
						cellType: "0",
						cellVal: "0.00",
						updateDesc: '',
						map: {}
					},
					"xfs_4_x_7": {
						cellCode: "xfs_4_" + hanh + "_7",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_4_x_8": {
						cellCode: "xfs_4_" + hanh + "_8",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_4_x_9": {
						cellCode: "xfs_4_" + hanh + "_9",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_4_x_9": {
						cellCode: "xfs_4_" + hanh + "_9",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_4_x_10": {
						cellCode: "xfs_4_" + hanh + "_10",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_4_x_11": {
						cellCode: "xfs_4_" + hanh + "_11",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_4_x_12": {
						cellCode: "xfs_4_" + hanh + "_12",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
				}
				this.tableDataI.splice(this.tableDataI.length, 0, table)

				let hanhII = 1000 + this.tableDataII.length
				let tableII = {
					hanh: hanh,
					"xfs_4_x_1.1": {
						cellCode: "xfs_4_" + hanhII + "_1.1",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_4_x_1.2": {
						cellCode: "xfs_4_" + hanhII + "_1.2",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_4_x_2": {
						cellCode: "xfs_4_" + hanhII + "_2",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_4_x_3": {
						cellCode: "xfs_4_" + hanhII + "_3",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_4_x_4": {
						cellCode: "xfs_4_" + hanhII + "_4",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_4_x_5": {
						cellCode: "xfs_4_" + hanhII + "_5",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_4_x_6": {
						cellCode: "xfs_4_" + hanhII + "_6",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_4_x_7": {
						cellCode: "xfs_4_" + hanhII + "_7",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
				}
				this.tableDataII.splice(this.tableDataII.length, 0, tableII)
			}
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SmallScaleVAT/index.less');
</style>